import { Component, TemplateFunction } from '@ribajs/core'
import { EventDispatcher } from '@ribajs/events'

interface Scope {
  loading: boolean
}

/**
 * Page spinner, shows when the page is loading
 */
export class SbSpinnerComponent extends Component {
  public static tagName = 'sb-spinner'

  public scope: Scope = {
    loading: false,
  }

  protected routerEvents = new EventDispatcher('main')

  static get observedAttributes(): string[] {
    return []
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbSpinnerComponent.observedAttributes)
    this.addEventListeners()
  }

  protected disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListeners()
  }

  protected onRouteReady() {
    this.scope.loading = false
  }

  protected onRouteChange() {
    this.scope.loading = true
  }

  protected addEventListeners() {
    this.routerEvents.on('initStateChange', this.onRouteChange, this)
    this.routerEvents.on('newPageReady', this.onRouteReady, this)
  }

  protected removeEventListeners() {
    this.routerEvents.off('initStateChange', this.onRouteChange, this)
    this.routerEvents.off('newPageReady', this.onRouteReady, this)
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
